<template>
  <div v-if="isOpen" class="fixed inset-0 top-[-1rem] bg-black bg-opacity-50 flex items-center justify-center z-50 w-full h-full p-8">
    <div class="bg-white rounded-lg shadow-lg w-full max-w-md p-6 relative dark:bg-dark-box-bg dark:border dark:border-dark-border dark:text-dark-text max-h-[90vh] overflow-y-auto" @click.stop ref="modal" :style="modalStyle">
      <!-- <h2 class="text-xl font-bold mb-4 text-gray-800 dark:text-dark-text">Stwórz nowe zamówienie</h2> -->
      <div 
        class="cursor-move mb-4 pb-2 border-b dark:border-dark-border"
        @mousedown="startDrag"
        @touchstart="startDrag"
      >
        <h2 class="text-2xl font-bold text-gray-800 dark:text-dark-text">Stwórz nowe zamówienie</h2>
      </div>
      <button class="absolute top-2 right-2 text-gray-500 hover:text-gray-700 focus:outline-none dark:text-dark-text dark:hover:text-dark-border-hover" @click="closeModal">
        <span class="text-xl">&times;</span>
      </button>
      <form @submit.prevent="submitForm" class="space-y-4">
        <!-- OrderLink -->
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1 dark:text-dark-text">Połączone Zlecenie:</label>
          <input
              v-model="localOrder.orderlink"
              type="text"
              @input="filterOrderLinks"
              @focus="showOrderLinkPicker"
              @blur="hideOrderLinkSuggestions"
              placeholder="Wpisz numer MPK istniejącego zlecenia"
              class="w-full p-2 border rounded-md focus:outline-none focus:ring dark:bg-dark-box-bg dark:border-dark-border dark:text-dark-text"
              :class="{ 'border-red-500 dark:border-dark-status-unavailable': localErrors.orderlink }"
          />
          <span v-if="localErrors.orderlink" class="text-red-500 text-sm mt-1 dark:text-dark-status-unavailable">{{ localErrors.orderlink }}</span>

          <!-- Lista podpowiedzi orderlink -->
          <ul v-if="showOrderLinkSuggestions && filteredOrderLinks.length" 
              class="bg-white border border-gray-300 rounded-md mt-1 dark:bg-dark-box-bg dark:border-dark-border max-h-48 overflow-y-auto shadow-lg z-10">
            <li
                v-for="order in filteredOrderLinks"
                :key="order.id"
                @mousedown.prevent="selectOrderLink(order)"
                class="p-3 cursor-pointer hover:bg-gray-100 dark:hover:bg-dark-border-hover border-b dark:border-dark-border last:border-b-0"
            >
              <div class="font-semibold text-gray-800 dark:text-dark-text">{{ order.mpk }}</div>
              <div class="text-sm text-gray-600 dark:text-dark-text-secondary mt-1">
                {{ order.companyName }} • {{ formatDate(order.date) }}
              </div>
            </li>
          </ul>
        </div>

        <!-- Firma -->
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1 dark:text-dark-text">Firma <span class="text-red-600">(*)</span>:</label>
          <input
              v-model="currentCompany.companyName"
              @input="filterCompanies"
              @click="showSuggestions = true; filterCompanies()"
              @blur="hideSuggestions"
              type="text"
              class="w-full p-2 border rounded-md focus:outline-none focus:ring dark:bg-dark-box-bg dark:border-dark-border dark:text-dark-text"
              :class="{ 'border-red-500 dark:border-dark-status-unavailable': localErrors.companyName }"
              placeholder="Wybierz firmę"
          />
          <span v-if="localErrors.companyName" class="text-red-500 text-sm mt-1 dark:text-dark-status-unavailable">{{ localErrors.companyName }}</span>

          <!-- Lista podpowiedzi -->
          <ul v-if="showSuggestions" class="bg-white border border-gray-300 rounded-md mt-1 dark:bg-dark-box-bg dark:border-dark-border max-h-32 overflow-y-auto">
            <li
                v-for="company in filteredCompanies"
                :key="company.id"
                @mousedown.prevent="selectCompany(company)"
                class="p-2 cursor-pointer hover:bg-gray-100 dark:hover:bg-dark-border-hover"
            >
              {{ company.companyName }}
            </li>
          </ul>
        </div>

        <!-- Uniq_ID -->
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1 dark:text-dark-text">Unikalne ID:</label>
          <input
              v-model="localOrder.uniq_id"
              type="text"
              placeholder="Wpisz unikalne id tego zlecenia."
              class="w-full p-2 border rounded-md focus:outline-none focus:ring dark:bg-dark-box-bg dark:border-dark-border dark:text-dark-text"
          />
          <span v-if="localErrors.uniq_id" class="text-red-500 text-sm mt-1 dark:text-dark-status-unavailable">{{ localErrors.uniq_id }}</span>
        </div>

        <!-- isDirection -->
         <div class="flex flex-row gap-2 ">
          <div class="flex items-center"> 
            <input
              type="checkbox"
              id="isDirection"
              v-model="localOrder.direction" 
              class="h-4 w-4 text-button-bg border-gray-300 rounded focus:ring-button-bg dark:text-dark-button-bg dark:focus:ring-dark-button-bg"
            />
            <label for="isDirection" class="ml-2 block text-sm font-semibold text-gray-700 dark:text-dark-text">
              Nie Liczyć dojazdu?
            </label>
          </div>

          <!-- isReturn -->
          <div class="flex items-center"> 
            <input
              type="checkbox"
              id="isReturn"
              v-model="localOrder.return" 
              class="h-4 w-4 text-button-bg border-gray-300 rounded focus:ring-button-bg dark:text-dark-button-bg dark:focus:ring-dark-button-bg"
            />
            <label for="isReturn" class="ml-2 block text-sm font-semibold text-gray-700 dark:text-dark-text">
              Nie Liczyć powrotu?
            </label>
          </div>
        </div>

        <!-- Data-->
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1 dark:text-dark-text">Data <span class="text-red-600">(*)</span>:</label>
          <input
              v-model="localOrder.date"
              type="date"
              class="w-full p-2 border rounded-md focus:outline-none focus:ring dark:bg-dark-box-bg dark:border-dark-border dark:text-dark-text"
              placeholder="Wybierz datę"
              @change="validateField('date')"
              @click="showDatePicker"
          />
          <span v-if="localErrors.date" class="text-red-500 text-sm mt-1 dark:text-dark-status-unavailable">{{ localErrors.date }}</span>
        </div>

        <!-- Kierowca -->
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1 dark:text-dark-text">Kierowca:</label>
          <input
              v-model="localOrder.driverName"
              @input="filterDrivers"
              @focus="showDriverSuggestions = true"
              @blur="hideDriverSuggestions"
              type="text"
              placeholder="Wyszukaj kierowcę po imieniu lub nazwisku"
              class="w-full p-2 border rounded-md focus:outline-none focus:ring dark:bg-dark-box-bg dark:border-dark-border dark:text-dark-text"
              :class="{ 'border-red-500 dark:border-dark-status-unavailable': localErrors.driverId }"
          />
          <span v-if="localErrors.driverId" class="text-red-500 text-sm mt-1 dark:text-dark-status-unavailable">{{ localErrors.driverId }}</span>

          <ul v-if="showDriverSuggestions && filteredDrivers.length && localOrder.driverName"
              class="bg-white border border-gray-300 rounded-md mt-1 dark:bg-dark-box-bg dark:border-dark-border">
            <li
                v-for="driver in filteredDrivers"
                :key="driver.id"
                @mousedown.prevent="selectDriver(driver)"
                class="p-2 cursor-pointer hover:bg-gray-100 dark:hover:bg-dark-border"
            >
               {{ driver.lastName }} {{ driver.firstName }}
            </li>
          </ul>
        </div>

        <!-- Pasażer -->
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1 dark:text-dark-text">Pasażer <span class="text-red-600">(*)</span>:</label>
          <input
              v-model="currentPassenger.passengerName"
              @input="filterPassengers"
              @click="showPassengerSuggestions = true; filterPassengers()"
              @blur="hidePassengerSuggestions"
              type="text"
              placeholder="Wybierz pasażera"
              class="w-full p-2 border rounded-md focus:outline-none focus:ring dark:bg-dark-box-bg dark:border-dark-border dark:text-dark-text"
              :class="{ 'border-red-500 dark:border-dark-status-unavailable': localErrors.passengerId }"
          />
          <span v-if="localErrors.passengerId" class="text-red-500 text-sm mt-1 dark:text-dark-status-unavailable">{{ localErrors.passengerId }}</span>

          <!-- Lista podpowiedzi pasażerów -->
          <ul v-if="showPassengerSuggestions" class="bg-white border border-gray-300 rounded-md mt-1 dark:bg-dark-box-bg dark:border-dark-border max-h-32 overflow-y-auto">
            <li
                v-for="passenger in filteredPassengers"
                :key="passenger.id"
                @mousedown.prevent="selectPassenger(passenger)"
                class="p-2 cursor-pointer hover:bg-gray-100 dark:hover:bg-dark-border-hover"
            >
               {{ passenger.lastName }} {{ passenger.firstName }}
            </li>
          </ul>
        </div>

        <!-- Dodatkowe pola po wybraniu pasażera -->
        <div v-if="currentPassenger.passengerId" class="mt-4 space-y-4">

          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1 dark:text-dark-text">Pozycja sortowania:</label>
            <input
                v-model="currentPassenger.sortOrder"
                type="number"
                placeholder="1"
                class="w-full p-2 border rounded-md focus:outline-none focus:ring dark:bg-dark-box-bg dark:border-dark-border dark:text-dark-text"
            />
          </div>

          <div class="flex items-center"> 
            <input
              type="checkbox"
              id="sharedDropoff"
              v-model="currentPassenger.sharedDropoff" 
              class="h-4 w-4 text-button-bg border-gray-300 rounded focus:ring-button-bg dark:text-dark-button-bg dark:focus:ring-dark-button-bg"
            />
            <label for="sharedDropoff" class="ml-2 block text-sm font-semibold text-gray-700 dark:text-dark-text">
              Wspólny adres?
            </label>
          </div>

          <!-- Godzina odbioru -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1 dark:text-dark-text">Godzina odbioru:</label>
            <input
                v-model="currentPassenger.pickupTime"
                type="text"
                placeholder="HH:MM"
                maxlength="5"
                class="w-full p-2 border rounded-md focus:outline-none focus:ring dark:bg-dark-box-bg dark:border-dark-border dark:text-dark-text"
                @input="formatTime"
            />
          </div>

          <!-- Adres Odbioru Opcje -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1 dark:text-dark-text">Adres Odbioru:</label>
            <div class="space-y-2">
              <div class="flex items-center">
                <input type="radio" id="pickup-home" v-model="pickupOption" value="home" @change="setPickupAddress" class="mr-2" />
                <label for="pickup-home" class="text-gray-700 dark:text-dark-text">Z domu (Adres zamieszkania)</label>
              </div>
              <div class="flex items-center">
                <input type="radio" id="pickup-work" v-model="pickupOption" value="work" @change="setPickupAddress" class="mr-2" />
                <label for="pickup-work" class="text-gray-700 dark:text-dark-text">Z pracy (Adres pracy)</label>
              </div>
              <input
                v-if="pickupOption === 'work'"
                v-model="currentPassenger.pickupAddress"
                type="text"
                placeholder="Wpisz adres pracy"
                @input="filterAddressSuggestions('pickup')"
                @focus="showPickupSuggestions = true"
                class="w-full p-2 border rounded-md focus:outline-none focus:ring dark:bg-dark-box-bg dark:border-dark-border dark:text-dark-text"
              />
              <ul v-if="showPickupSuggestions && pickupOption === 'work'" class="bg-white border border-gray-300 rounded-md mt-1 dark:bg-dark-box-bg dark:border-dark-border">
                <li
                  v-for="address in filteredPickupAddresses.slice(0, 3)"
                  :key="address.combined"
                  @mousedown="selectPickupAddress(address)"
                  class="p-2 cursor-pointer hover:bg-gray-100 dark:hover:bg-dark-border-hover"
                >
                  {{ address.combined }}
                </li>
              </ul>
              <div class="flex items-center">
                <input type="radio" id="pickup-manual" v-model="pickupOption" value="manual" @change="setPickupAddress" class="mr-2" />
                <label for="pickup-manual" class="text-gray-700 dark:text-dark-text">Ręczne wpisywanie</label>
              </div>
              <input
                v-if="pickupOption === 'manual'"
                v-model="currentPassenger.pickupAddress"
                type="text"
                placeholder="Wpisz adres odbioru"
                @input="filterAddressSuggestions('pickup')"
                @focus="showPickupSuggestions = true"
                @blur="hidePickupSuggestions"
                class="w-full p-2 border rounded-md focus:outline-none focus:ring dark:bg-dark-box-bg dark:border-dark-border dark:text-dark-text mt-2"
              />
              <p v-if="pickupOption === 'home'" class="mt-2">Wybrany Adres: {{ currentPassenger.pickupAddress }}</p>
              <ul v-if="showPickupSuggestions && pickupOption === 'manual'" class="bg-white border border-gray-300 rounded-md mt-1 dark:bg-dark-box-bg dark:border-dark-border">
                <li
                  v-for="address in filteredPickupAddresses.slice(0, 3)"
                  :key="address.combined"
                  @mousedown="selectPickupAddress(address)"
                  class="p-2 cursor-pointer hover:bg-gray-100 dark:hover:bg-dark-border-hover"
                >
                  {{ address.combined }}
                </li>
              </ul>
            </div>
          </div>

          <!-- Adres Dowozu Opcje -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1 dark:text-dark-text">Adres Dowozu:</label>
            <div class="space-y-2">
              <div class="flex items-center">
                <input type="radio" id="dropoff-home" v-model="dropoffOption" value="home" @change="setDropoffAddress" class="mr-2"/>
                <label for="dropoff-home" class="text-gray-700 dark:text-dark-text">Do Domu (Adres zamieszkania)</label>
              </div>
              <div class="flex items-center">
                <input type="radio" id="dropoff-work" v-model="dropoffOption" value="work" @change="setDropoffAddress" class="mr-2" />
                <label for="dropoff-work" class="text-gray-700 dark:text-dark-text">Do Pracy (Adres pracy)</label>
              </div>
              <input
                v-if="dropoffOption === 'work'"
                v-model="currentPassenger.dropoffAddress"
                type="text"
                placeholder="Wpisz adres pracy"
                @input="filterAddressSuggestions('dropoff')"
                @focus="showDropoffSuggestions = true"
                class="w-full p-2 border rounded-md focus:outline-none focus:ring dark:bg-dark-box-bg dark:border-dark-border dark:text-dark-text"
              />
              <ul v-if="showDropoffSuggestions && dropoffOption === 'work'" class="bg-white border border-gray-300 rounded-md mt-1 dark:bg-dark-box-bg dark:border-dark-border">
                <li
                  v-for="address in filteredDropoffAddresses.slice(0, 3)"
                  :key="address.combined"
                  @mousedown="selectDropoffAddress(address)"
                  class="p-2 cursor-pointer hover:bg-gray-100 dark:hover:bg-dark-border-hover"
                >
                  {{ address.combined }}
                </li>
              </ul>
              <div class="flex items-center">
                <input type="radio" id="dropoff-manual" v-model="dropoffOption" value="manual" @change="setDropoffAddress" class="mr-2"  />
                <label for="dropoff-manual" class="text-gray-700 dark:text-dark-text">Ręczne wpisywanie</label>
              </div>
              <input
                v-if="dropoffOption === 'manual'"
                v-model="currentPassenger.dropoffAddress"
                type="text"
                placeholder="Wpisz adres dowozu"
                @input="filterAddressSuggestions('dropoff')"
                @focus="showDropoffSuggestions = true"
                @blur="hideDropoffSuggestions"
                class="w-full p-2 border rounded-md focus:outline-none focus:ring dark:bg-dark-box-bg dark:border-dark-border dark:text-dark-text mt-2"
              />
              <p v-if="dropoffOption === 'home'" class="mt-2">Wybrany Adres: {{ currentPassenger.dropoffAddress }}</p>
              <ul v-if="showDropoffSuggestions && dropoffOption === 'manual'" class="bg-white border border-gray-300 rounded-md mt-1 dark:bg-dark-box-bg dark:border-dark-border">
                <li
                  v-for="address in filteredDropoffAddresses.slice(0, 3)"
                  :key="address.combined"
                  @mousedown="selectDropoffAddress(address)"
                  class="p-2 cursor-pointer hover:bg-gray-100 dark:hover:bg-dark-border-hover"
                >
                  {{ address.combined }}
                </li>
              </ul>
            </div>
          </div>
              <div class="flex items-center mt-4">
                  <input type="checkbox" id="swap-passenger" v-model="swapEnabled" class="mr-2" />
                  <label for="swap-passenger" class="text-gray-700 dark:text-dark-text">Podmiana (zakończenie na trasie)</label>
              </div>

              <div v-if="swapEnabled" class="mt-4">
                <label class="block text-sm font-medium text-gray-700 mb-1 dark:text-dark-text">Wybierz pasażera do podmiany:</label>
                <input
                    v-model="swappedPassenger.passengerName"
                    @input="filterSwappedPassengers"
                    @click="showSwappedPassengerSuggestions = true"
                    @blur="hideSwappedPassengerSuggestions"
                    type="text"
                    placeholder="Wpisz imię lub nazwisko"
                    class="w-full p-2 border rounded-md focus:outline-none focus:ring dark:bg-dark-box-bg dark:border-dark-border dark:text-dark-text"
                />

                <label class="block text-sm font-medium text-gray-700 mb-1 dark:text-dark-text">Pozycja sortowania:</label>
                <input
                    v-model="swappedPassenger.sortOrder"
                    type="number"
                    placeholder="1"
                    class="w-full p-2 border rounded-md focus:outline-none focus:ring dark:bg-dark-box-bg dark:border-dark-border dark:text-dark-text"
                />

                <div class="flex items-center"> 
                  <input
                    type="checkbox"
                    id="sharedDropoff"
                    v-model="swappedPassenger.sharedDropoff" 
                    class="h-4 w-4 text-button-bg border-gray-300 rounded focus:ring-button-bg dark:text-dark-button-bg dark:focus:ring-dark-button-bg"
                  />
                  <label for="sharedDropoff" class="ml-2 block text-sm font-semibold text-gray-700 dark:text-dark-text">
                    Wspólny adres?
                  </label>
                </div>

                <ul v-if="showSwappedPassengerSuggestions" class="bg-white border border-gray-300 rounded-md mt-1 dark:bg-dark-box-bg dark:border-dark-border max-h-32 overflow-y-auto">
                    <li
                        v-for="passenger in filteredSwappedPassengers"
                        :key="passenger.id"
                        @mousedown.prevent="selectSwappedPassenger(passenger, index)"
                        class="p-2 cursor-pointer hover:bg-gray-100 dark:hover:bg-dark-border-hover"
                    >
                        {{ passenger.lastName }} {{ passenger.firstName }}
                    </li>
                </ul>

                <div v-if="swappedPassenger.passengerId">
                  <label class="block text-sm font-medium text-gray-700 mb-1 dark:text-dark-text">Godzina odbioru:</label>
                  <input
                      v-model="swappedPassenger.pickupTime"
                      type="text"
                      placeholder="HH:MM"
                      maxlength="5"
                      class="w-full p-2 border rounded-md focus:outline-none focus:ring dark:bg-dark-box-bg dark:border-dark-border dark:text-dark-text"
                      @input="formatTimeForSwapped(swappedPassenger)"
                  />
                </div>

                <div v-if="swappedPassenger.passengerId" class="mt-4">
                    <label class="block text-sm font-medium text-gray-700 mb-1 dark:text-dark-text">Adres dowozu dla drugiego pasażera:</label>
                    <input
                        v-model="swappedPassenger.dropoffAddress"
                        @input="filterSwappedDropoffAddresses"
                        @focus="showSwappedDropoffSuggestions = true; filterSwappedDropoffAddresses()"
                        @blur="hideSwappedDropoffSuggestions"
                        type="text"
                        placeholder="Wpisz adres dowozu"
                        class="w-full p-2 border rounded-md focus:outline-none focus:ring dark:bg-dark-box-bg dark:border-dark-border dark:text-dark-text"
                    />
                    <ul v-if="showSwappedDropoffSuggestions" class="bg-white border border-gray-300 rounded-md mt-1 dark:bg-dark-box-bg dark:border-dark-border max-h-32 overflow-y-auto">
                      <li
                        v-for="address in filteredSwappedDropoffAddresses.slice(0, 3)"
                        :key="address.combined"
                        @mousedown.prevent="selectSwappedDropoffAddress(address)"
                        class="p-2 cursor-pointer hover:bg-gray-100 dark:hover:bg-dark-border-hover"
                      >
                        {{ address.combined }}
                      </li>
                    </ul>
                </div>

                <hr class="my-4">
            </div>
        </div>

        <!-- Wyświetlanie listy dodanych pasażerów -->
        <div v-if="localOrder.passengers.length" class="mt-6 space-y-4">
          <div v-for="(passenger, index) in localOrder.passengers" :key="index" class="border p-4 rounded-md bg-gray-50 dark:bg-dark-box-bg">
            <div v-if="editIndex === index">
              <label class="block text-sm font-medium text-gray-700 mb-1 dark:text-dark-text">Pasażer:</label>
              <input v-model="editPassenger.passengerName" type="text" class="w-full p-2 border rounded-md focus:outline-none focus:ring dark:bg-dark-box-bg dark:border-dark-border dark:text-dark-text" />

              <div>
                <label class="block text-sm font-medium text-gray-700 mb-1 dark:text-dark-text">Pozycja sortowania:</label>
                <input
                    v-model="editPassenger.sortOrder"
                    type="number"
                    placeholder="1"
                    class="w-full p-2 border rounded-md focus:outline-none focus:ring dark:bg-dark-box-bg dark:border-dark-border dark:text-dark-text"
                />
              </div>

              <div class="flex items-center"> 
                <input
                  type="checkbox"
                  id="sharedDropoff"
                  v-model="editPassenger.sharedDropoff" 
                  class="h-4 w-4 text-button-bg border-gray-300 rounded focus:ring-button-bg dark:text-dark-button-bg dark:focus:ring-dark-button-bg"
                />
                <label for="sharedDropoff" class="ml-2 block text-sm font-semibold text-gray-700 dark:text-dark-text">
                  Wspólny adres?
                </label>
              </div>

              <label class="block text-sm font-medium text-gray-700 mb-1 dark:text-dark-text">Godzina odbioru:</label>
              <input
                  v-model="editPassenger.pickupTime"
                  type="text"
                  placeholder="HH:MM"
                  maxlength="5"
                  class="w-full p-2 border rounded-md focus:outline-none focus:ring dark:bg-dark-box-bg dark:border-dark-border dark:text-dark-text"
                  @input="formatTimeForEdit"
              />

              <label class="block text-sm font-medium text-gray-700 mb-1 dark:text-dark-text">Adres Odbioru:</label>
              <input
                  v-model="editPassenger.pickupAddress"
                  type="text"
                  placeholder="Wpisz adres pracy"
                  @input="filterAddressSuggestions('pickup')"
                  @focus="showPickupSuggestions = true"
                  class="w-full p-2 border rounded-md focus:outline-none focus:ring dark:bg-dark-box-bg dark:border-dark-border dark:text-dark-text"
                />

                <ul v-if="showPickupSuggestions && editPassenger.pickupAddress" class="bg-white border border-gray-300 rounded-md mt-1 dark:bg-dark-box-bg dark:border-dark-border">
                  <li
                    v-for="address in filteredPickupAddresses.slice(0, 3)"
                    :key="address.combined"
                    @click="selectPickupAddress(address, 'edit')"
                    class="p-2 cursor-pointer hover:bg-gray-100 dark:hover:bg-dark-border-hover"
                  >
                    {{ address.combined }}
                  </li>
                </ul>

              <label class="block text-sm font-medium text-gray-700 mb-1 dark:text-dark-text">Adres Dowozu:</label>
              <input
                  v-model="editPassenger.dropoffAddress"
                  type="text"
                  placeholder="Wpisz adres pracy"
                  @input="filterAddressSuggestions('dropoff')"
                  @focus="showDropoffSuggestions = true"
                  class="w-full p-2 border rounded-md focus:outline-none focus:ring dark:bg-dark-box-bg dark:border-dark-border dark:text-dark-text"
                />

                <ul v-if="showDropoffSuggestions && editPassenger.dropoffAddress" class="bg-white border border-gray-300 rounded-md mt-1 dark:bg-dark-box-bg dark:border-dark-border">
                  <li
                    v-for="address in filteredDropoffAddresses.slice(0, 3)"
                    :key="address.combined"
                    @click="selectDropoffAddress(address, 'edit')"
                    class="p-2 cursor-pointer hover:bg-gray-100 dark:hover:bg-dark-border-hover"
                  >
                    {{ address.combined }}
                  </li>
                </ul>


              <div class="flex items-center mt-4">
                  <input type="checkbox" id="swap-passenger" v-model="swapEnabled" class="mr-2" />
                  <label for="swap-passenger" class="text-gray-700 dark:text-dark-text">Podmiana (zakończenie na trasie)</label>
              </div>

              <div v-if="swapEnabled" class="mt-4">
                <label class="block text-sm font-medium text-gray-700 mb-1 dark:text-dark-text">Wybierz pasażera do podmiany:</label>
                <input
                    v-model="swappedPassenger.passengerName"
                    @input="filterSwappedPassengers"
                    @click="showSwappedPassengerSuggestions = true"
                    @blur="hideSwappedPassengerSuggestions"
                    type="text"
                    placeholder="Wpisz imię lub nazwisko"
                    class="w-full p-2 border rounded-md focus:outline-none focus:ring dark:bg-dark-box-bg dark:border-dark-border dark:text-dark-text"
                />

                <ul v-if="showSwappedPassengerSuggestions" class="bg-white border border-gray-300 rounded-md mt-1 dark:bg-dark-box-bg dark:border-dark-border max-h-32 overflow-y-auto">
                    <li
                        v-for="passenger in filteredSwappedPassengers"
                        :key="passenger.id"
                        @mousedown.prevent="selectSwappedPassenger(passenger)"
                        class="p-2 cursor-pointer hover:bg-gray-100 dark:hover:bg-dark-border-hover"
                    >
                        {{ passenger.lastName }} {{ passenger.firstName }}
                    </li>
                </ul>

                <label class="block text-sm font-medium text-gray-700 mb-1 dark:text-dark-text">Pozycja sortowania:</label>
                <input
                    v-model="swappedPassenger.sortOrder"
                    type="number"
                    placeholder="1"
                    class="w-full p-2 border rounded-md focus:outline-none focus:ring dark:bg-dark-box-bg dark:border-dark-border dark:text-dark-text"
                />

                <div class="flex items-center"> 
                  <input
                    type="checkbox"
                    id="sharedDropoff"
                    v-model="swappedPassenger.sharedDropoff" 
                    class="h-4 w-4 text-button-bg border-gray-300 rounded focus:ring-button-bg dark:text-dark-button-bg dark:focus:ring-dark-button-bg"
                  />
                  <label for="sharedDropoff" class="ml-2 block text-sm font-semibold text-gray-700 dark:text-dark-text">
                    Wspólny adres?
                  </label>
                </div>

                <div v-if="swappedPassenger.passengerId">
                  <label class="block text-sm font-medium text-gray-700 mb-1 dark:text-dark-text">Godzina odbioru:</label>
                  <input
                      v-model="swappedPassenger.pickupTime"
                      type="text"
                      placeholder="HH:MM"
                      maxlength="5"
                      class="w-full p-2 border rounded-md focus:outline-none focus:ring dark:bg-dark-box-bg dark:border-dark-border dark:text-dark-text"
                      @input="formatTimeForSwapped(swappedPassenger)"
                  />
                </div>

                <div v-if="swappedPassenger.passengerId" class="mt-4">
                    <label class="block text-sm font-medium text-gray-700 mb-1 dark:text-dark-text">Adres dowozu dla drugiego pasażera:</label>
                    <input
                        v-model="swappedPassenger.dropoffAddress"
                        @input="filterSwappedDropoffAddresses"
                        @focus="showSwappedDropoffSuggestions = true; filterSwappedDropoffAddresses()"
                        @blur="hideSwappedDropoffSuggestions"
                        type="text"
                        placeholder="Wpisz adres dowozu"
                        class="w-full p-2 border rounded-md focus:outline-none focus:ring dark:bg-dark-box-bg dark:border-dark-border dark:text-dark-text"
                    />
                    <ul v-if="showSwappedDropoffSuggestions" class="bg-white border border-gray-300 rounded-md mt-1 dark:bg-dark-box-bg dark:border-dark-border max-h-32 overflow-y-auto">
                      <li
                        v-for="address in filteredSwappedDropoffAddresses.slice(0, 3)"
                        :key="address.combined"
                        @mousedown.prevent="selectSwappedDropoffAddress(address)"
                        class="p-2 cursor-pointer hover:bg-gray-100 dark:hover:bg-dark-border-hover"
                      >
                        {{ address.combined }}
                      </li>
                    </ul>
                </div>

                <hr class="my-4">
            </div>

              <button @click="savePassenger(index)" class="mt-2 bg-blue-500 text-white py-2 px-4 rounded-md hover:bg-blue-600 focus:outline-none focus:ring">Zapisz</button>
            </div>
            <div v-else>
              <p><strong>Pasażer:</strong> {{ passenger.passengerName }}</p>
              <p><strong>Godzina odbioru:</strong> {{ passenger.pickupTime }}</p>
              <p><strong>Adres Odbioru:</strong> {{ passenger.pickupAddress }}</p>
              <p><strong>Adres Dowozu:</strong> {{ passenger.dropoffAddress }}</p>
              <button @click="editPassengerDetails(index)" class="mt-2 bg-teal-700 text-white py-2 px-4 rounded-md hover:bg-teal-600 focus:outline-none focus:ring">Edytuj</button>
            </div>
          </div>
        </div>

        <button type="submit"
                class="w-full bg-button-bg text-button-text py-2 rounded-md hover:bg-button-hover focus:outline-none focus:ring dark:bg-dark-button-bg dark:hover:bg-dark-button-hover">
          Stwórz zamówienie
        </button>


      </form>
    </div>
  </div>
</template>

<style scoped>
/* Pasek przewijania w trybie ciemnym */
.dark .overflow-y-auto::-webkit-scrollbar {
  width: 8px; /* Szerokość paska przewijania */
}

.dark .overflow-y-auto::-webkit-scrollbar-thumb {
  background-color: #2c7a7a; /* Teal-700 */
  border-radius: 8px; /* Zaokrąglenie suwaka */
  border: 2px solid #1a5d5d; /* Ciemniejszy odcień teal dla krawędzi suwaka */
}

.dark .overflow-y-auto::-webkit-scrollbar-track {
  background-color: #333333; /* Ciemne tło dla śledzenia paska */
  border-radius: 8px; /* Zaokrąglenie tła paska */
}

/* Pasek przewijania w trybie jasnym */
.overflow-y-auto::-webkit-scrollbar {
  width: 8px; /* Szerokość paska przewijania */
}

.overflow-y-auto::-webkit-scrollbar-thumb {
  background-color: #d1d5db; /* Jasnoszary kolor suwaka (szary) */
  border-radius: 8px; /* Zaokrąglenie suwaka */
  border: 2px solid #9ca3af; /* Ciemniejszy szary dla krawędzi suwaka */
}

.overflow-y-auto::-webkit-scrollbar-track {
  background-color: #f3f4f6; /* Jasnoszare tło dla śledzenia paska */
  border-radius: 8px; /* Zaokrąglenie tła paska */
}

.cursor-move {
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}

.dragging {
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}
</style>

<script>
import hotelService from '@/services/hotelService';
import stationService from '@/services/stationService';
import passengersService from '@/services/passengersService';
import driverService from '@/services/driversService';
import companiesService from '@/services/companiesService';

export default {
  props: {
    isOpen: {
      type: Boolean,
      required: true
    },
    errors: {
      type: Object,
      required: true
    },
    orders: {
      type: Object,
      required: true
    },
    newOrder: {
      type: Object,
      required: false,
      default: () => ({
        date: '',
        mpk: '',
        companyId: null,
        driverId: null,
        uniq_id: '',
        passengers: [],
        isDirection: false
      })
    }
  },
  data() {
    return {
      localOrder: { ...this.newOrder },
      currentCompany: {
        companyName: '',
        companyId: null,
      },
      currentPassenger: {
        passengerName: '',
        passengerId: null,
        pickupTime: '',
        city: '',
        pickupAddress: '',
        dropoffAddress: '',
        homeAddress: '',
        workAddress: '',
        swapped: false,
        sortOrder: null,
        sharedDropoff: false
      },
      localErrors: { ...this.errors },
      filteredCompanies: [],
      showSuggestions: false,
      filteredPassengers: [],
      showPassengerSuggestions: false,
      driverAddress: '',
      pickupOption: '',
      dropoffOption: '',
      stations: [],
      hotels: [],
      passengers: [],
      companies: [],
      drivers: [],
      filteredPickupAddresses: [],
      filteredDropoffAddresses: [],
      showPickupSuggestions: false,
      showDropoffSuggestions: false,
      defaultAddresses: [],
      editIndex: null,
      editPassenger: {},
      swapEnabled: false,
      swapPassengerSelected: false,
      swappedPassenger: {
        passengerName: '',
        passengerId: null,
        pickupAddress: '',
        dropoffAddress: '',
        pickupTime: '',
        swapped: true,
        sortOrder: null,
        sharedDropoff: false
      },
      filteredSwappedPassengers: [],
      showSwappedPassengerSuggestions: false,
      filteredSwappedDropoffAddresses: [],
      showSwappedDropoffSuggestions: false,
      filteredDrivers: [], // Nowa lista na przefiltrowanych kierowców
      showDriverSuggestions: false, // Flaga do pokazywania/ukrywania listy
      isDragging: false,
      dragOffset: { x: 0, y: 0 },
      modalPosition: { x: 0, y: 0 },
      filteredOrderLinks: [],
      showOrderLinkSuggestions: false
    };
  },
  watch: {
    // 'localOrder.driverId': function(newDriverId) {
    //   this.selectDriver(newDriverId);
    // },
    isOpen: {
      immediate: true, // Wykonuje się również od razu po zamontowaniu
      handler(newVal) {
        if (newVal) {
          this.fetchModalData();
          this.initForm();
        }
      }
    },
    newOrder(newVal) {
      this.localOrder = { ...newVal };
    },
    swapEnabled(newVal) {
      if (!newVal) {
        this.swapPassengerSelected = false;
        this.swappedPassenger = { ...this.$options.data().swappedPassenger };
      }
    },
    'localOrder.orderlink': function(newVal) {
      if (newVal) {
        this.filterOrderLinks();
      } else {
        this.filteredOrderLinks = [];
        this.showOrderLinkSuggestions = false;
      }
    }
  },
  computed: {
    modalStyle() {
      return {
        transform: `translate(${this.modalPosition.x}px, ${this.modalPosition.y}px)`
      };
    }
  },
  methods: {
    async fetchModalData() {
      try {
        const stationsData = await stationService.getAllStations();
        this.stations = stationsData.data;
      } catch (error) {
        console.error('Nie udało się pobrać stacji:', error);
      }

      try {
        const hotelsData = await hotelService.getAllHotels();
        this.hotels = hotelsData.data;
      } catch (error) {
        console.error('Nie udało się pobrać hoteli:', error);
      }

      try {
        const passengersData = await passengersService.getAllPassengers();
        this.passengers = passengersData.data;
      } catch (error) {
        console.error('Nie udało się pobrać pasażerów:', error);
      }

      try {
        const driversData = await driverService.getAllDrivers();
        this.drivers = driversData.data;
      } catch (error) {
        console.error('Nie udało się pobrać kierowców:', error);
      }

      try {
        const companiesData = await companiesService.getAllCompanies();
        this.companies = companiesData.data;
      } catch (error) {
        console.error('Nie udało się pobrać firm:', error);
      }
    },
    initForm() {
      if (this.initialData) {
        this.formData = JSON.parse(JSON.stringify(this.initialData));
      } else {
        this.resetForm();
      }
    },
    filterOrderLinks() {
      try {
        const query = this.localOrder.orderlink?.trim().toLowerCase() || '';
        
        if (!query) {
          this.filteredOrderLinks = [];
          this.showOrderLinkSuggestions = false;
          return;
        }

        const existingOrders = this.orders || [];
        
        if (!Array.isArray(existingOrders)) {
          console.warn('existingOrders nie jest tablicą:', existingOrders);
          this.filteredOrderLinks = [];
          return;
        }

        this.filteredOrderLinks = existingOrders
          .filter(order => {
            if (!order || !order.mpk) return false;
            return order.mpk.toLowerCase().includes(query) && 
                  order.mpk !== this.localOrder.mpk;
          })
          .map(order => ({
            mpk: order.mpk,
            id: order.id,
            companyName: order.company?.companyName || 'Brak firmy',
            date: order.date
          }))
          .slice(0, 5);

        this.showOrderLinkSuggestions = this.filteredOrderLinks.length > 0;
      } catch (error) {
        console.error('Błąd w filterOrderLinks:', error);
        this.filteredOrderLinks = [];
        this.showOrderLinkSuggestions = false;
      }
    },
    selectOrderLink(order) {
      this.localOrder.orderlink = order.mpk;
      this.showOrderLinkSuggestions = false;
    },
    hideOrderLinkSuggestions() {
      setTimeout(() => {
        this.showOrderLinkSuggestions = false;
      }, 150);
    },
    showOrderLinkPicker() {
      if (this.localOrder.orderlink) {
        this.filterOrderLinks();
      }
      this.showOrderLinkSuggestions = true;
    },
    formatDate(dateString) {
      if (!dateString) return 'Brak daty';
      const date = new Date(dateString);
      return date.toLocaleDateString('pl-PL');
    },
    formatTime() {
      let value = this.currentPassenger.pickupTime.replace(/\D/g, ''); // Usuń wszystkie znaki, które nie są cyframi

      if (value.length > 2) {
        value = value.substring(0, 2) + ':' + value.substring(2, 4);
      }
      
      // Upewnij się, że nie ma więcej niż 5 znaków
      if (value.length > 5) {
        value = value.substring(0, 5);
      }

      this.currentPassenger.pickupTime = value;
    },
    formatTimeForEdit() {
      let value = this.editPassenger.pickupTime.replace(/\D/g, '');

      if (value.length > 2) {
        value = value.substring(0, 2) + ':' + value.substring(2, 4);
      }
      
      if (value.length > 5) {
        value = value.substring(0, 5);
      }

      this.editPassenger.pickupTime = value;
    },
    formatTimeForSwapped(swappedPassenger) {
      let value = swappedPassenger.pickupTime.replace(/\D/g, '');

      if (value.length > 2) {
        value = value.substring(0, 2) + ':' + value.substring(2, 4);
      }
      
      if (value.length > 5) {
        value = value.substring(0, 5);
      }

      swappedPassenger.pickupTime = value;
    },
    validateTime(timeString) {
      const pattern = /^(?:2[0-3]|[01]?[0-9]):[0-5]?[0-9]$/;
      return pattern.test(timeString);
    },
    checkAndAddPassenger() {
      console.log('checkAndAddPassenger wywołane', {
        passengerName: this.currentPassenger.passengerName,
        passengerId: this.currentPassenger.passengerId,
        pickupTime: this.currentPassenger.pickupTime,
        pickupAddress: this.currentPassenger.pickupAddress,
        dropoffAddress: this.currentPassenger.dropoffAddress
      });
      if (
        this.currentPassenger?.passengerName &&
        this.currentPassenger?.passengerId &&
        this.currentPassenger?.pickupAddress &&
        this.currentPassenger?.dropoffAddress
      ) {
        this.addPassenger();
      } else {
        console.log('Nie wszystkie wymagane pola są wypełnione');
      }
    },
    editPassengerDetails(index) {
      this.editIndex = index;
      this.editPassenger = { ...this.localOrder.passengers[index] };
    },
    // savePassenger(index) {
    //   console.log(index, this.editPassenger);
    //   console.log(2, this.swappedPassenger);
    //   // this.localOrder.passengers[index] = { ...this.editPassenger };
    //   // this.editIndex = null;
    //   // this.editPassenger = {};
    // },
    savePassenger(index) {
      // Zapisz zmiany w edytowanym pasażerze
      this.localOrder.passengers[index] = { ...this.editPassenger };

      // Sprawdź, czy podmiana jest aktywna i czy wybrano pasażera do podmiany
      if (this.swapEnabled && this.swappedPassenger.passengerId) {
        // Dodaj pasażera z podmiany do listy
        this.localOrder.passengers.push({
          passengerName: this.swappedPassenger.passengerName,
          firstName: this.swappedPassenger.firstName,
          lastName: this.swappedPassenger.lastName,
          passengerId: this.swappedPassenger.passengerId,
          pickupAddress: this.editPassenger.dropoffAddress,
          dropoffAddress: this.swappedPassenger.dropoffAddress,
          pickupTime: this.swappedPassenger.pickupTime,
          swapped: true,
          swappedPassengerId: this.editPassenger.passengerId,
          sortOrder: this.swappedPassenger.sortOrder,
          sharedDropoff: this.swappedPassenger.sharedDropoff
        });
      }

      // Zresetuj stan edycji
      this.editIndex = null;
      this.editPassenger = {};
      this.swapEnabled = false; // Zresetuj flagę podmiany
      this.swappedPassenger = { ...this.$options.data().swappedPassenger }; // Zresetuj obiekt pasażera podmiany
    },
    removeDiacritics(text) {
      if (typeof text !== 'string' || !text) return '';
      
      // Normalizacja, usunięcie diakrytyków i specjalna obsługa dla 'ł'
      return text
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/ł/g, 'l'); 
    },
    filterAddressSuggestions(type) {
      let query = '';
      let addresses = [];
      let allSuggestions = [];

      if (!Array.isArray(this.stations)) {
        console.error('Stacje nie są tablicą:', this.stations);
        return;
      }

      if (!Array.isArray(this.hotels)) {
        console.error('Hotele nie są tablicą:', this.hotels);
        return;
      }

      if (type === 'pickup') {
        query = this.removeDiacritics(this.currentPassenger.pickupAddress);
        addresses = [this.currentPassenger.city + " " + this.currentPassenger.homeAddress, this.currentPassenger.workAddress].filter(addr => addr);
        
        const filteredAddresses = addresses.filter(address => 
          this.removeDiacritics(address).includes(query)
        );
        
        const filteredStations = this.stations.filter(station => 
          this.removeDiacritics(station.name).includes(query)
        );
        
        const filteredHotels = this.hotels.filter(hotel => 
          this.removeDiacritics(hotel.name).includes(query) || 
          (hotel.address && this.removeDiacritics(hotel.address).includes(query))
        );
        
        allSuggestions = [
          ...filteredAddresses.map(addr => ({ combined: addr, name: addr, postcode: '' })),
          ...filteredStations.map(station => ({ 
            combined: `${station.name} ${station.postcode || 'Brak kodu'}`,
            name: station.name, 
            postcode: station.postcode || 'Brak kodu' 
          })),
          ...filteredHotels.map(hotel => ({
            combined: `${hotel.address || 'Brak adresu'} (${hotel.name})`, 
            name: hotel.name,
            address: hotel.address || 'Brak adresu'
          }))
        ];
        this.filteredPickupAddresses = allSuggestions;
      } else if (type === 'dropoff') {
        query = this.removeDiacritics(this.currentPassenger.dropoffAddress);
        addresses = [this.currentPassenger.city + " " + this.currentPassenger.homeAddress, this.currentPassenger.workAddress].filter(addr => addr);
        
        const filteredAddresses = addresses.filter(address => 
          this.removeDiacritics(address).includes(query)
        );
        
        const filteredStations = this.stations.filter(station => 
          this.removeDiacritics(station.name).includes(query)
        );
        
        const filteredHotels = this.hotels.filter(hotel => 
          this.removeDiacritics(hotel.name).includes(query) || 
          (hotel.address && this.removeDiacritics(hotel.address).includes(query))
        );
        
        allSuggestions = [
          ...filteredAddresses.map(addr => ({ combined: addr, name: addr, postcode: '' })),
          ...filteredStations.map(station => ({ 
            combined: `${station.name} ${station.postcode || 'Brak kodu'}`, 
            name: station.name, 
            postcode: station.postcode || 'Brak kodu' 
          })),
          ...filteredHotels.map(hotel => ({
            combined: `${hotel.address || 'Brak adresu'} (${hotel.name})`, 
            name: hotel.name,
            address: hotel.address || 'Brak adresu'
          }))
        ];
        this.filteredDropoffAddresses = allSuggestions;
      }
    },
    selectPickupAddress(address, mode = 'current') {
      // if (mode === 'edit') {
      //   this.editPassenger.pickupAddress = address.combined;
      // } else {
      //   this.currentPassenger.pickupAddress = address.combined;
      // }
      // this.checkAndAddPassenger();
      // this.showPickupSuggestions = false;
      const finalAddress = address.address || address.combined;
      
      // 2. Przypisanie adresu
      if (mode === 'edit') {
        this.editPassenger.pickupAddress = finalAddress;
      } else {
        this.currentPassenger.pickupAddress = finalAddress;
      }
      
      // 3. Zakończenie
      this.checkAndAddPassenger();
      this.showPickupSuggestions = false;
    },
    selectDropoffAddress(address, mode = 'current') {
      const finalAddress = address.address || address.combined;

      if (mode === 'edit') {
        this.editPassenger.dropoffAddress = finalAddress;
      } else {
        this.currentPassenger.dropoffAddress = finalAddress;
      }
      this.checkAndAddPassenger();
      this.showDropoffSuggestions = false;
    },
    hidePickupSuggestions() {
      console.log('hidePickupSuggestions wywołane');
      setTimeout(() => {
        this.showPickupSuggestions = false;
        this.checkAndAddPassenger();
      }, 100);
    },
    hideDropoffSuggestions() {
      console.log('hideDropoffSuggestions wywołane');
      setTimeout(() => {
        this.showDropoffSuggestions = false;
        this.checkAndAddPassenger();
      }, 100);
    },
    setPickupAddress() {
      if (this.pickupOption === 'home') {
        this.currentPassenger.pickupAddress = this.currentPassenger.city + " " + this.currentPassenger.homeAddress || 'Adres Zamieszkania';
        this.checkAndAddPassenger();
      } else if (this.pickupOption === 'work') {
        this.currentPassenger.pickupAddress = this.currentPassenger.workAddress || '';
        this.filterAddressSuggestions('pickup');
      } else if (this.pickupOption === 'manual') {
        this.currentPassenger.pickupAddress = '';
        this.filterAddressSuggestions('pickup');
      }
      
      if (this.currentPassenger.pickupAddress) {
        this.checkAndAddPassenger();
      }
    },
    setDropoffAddress() {
      if (this.dropoffOption === 'home') {
        this.currentPassenger.dropoffAddress = this.currentPassenger.city + " " + this.currentPassenger.homeAddress || 'Adres Domu';
        this.checkAndAddPassenger();
      } else if (this.dropoffOption === 'work') {
        this.currentPassenger.dropoffAddress = this.currentPassenger.workAddress || '';
        this.filterAddressSuggestions('dropoff');
      } else if (this.dropoffOption === 'manual') {
        this.currentPassenger.dropoffAddress = '';
        this.filterAddressSuggestions('dropoff');
      }

      if (this.currentPassenger.dropoffAddress) {
        this.checkAndAddPassenger();
      }
    },
    filterCompanies() {
      const query = this.currentCompany.companyName.toLowerCase();
      if (query) {
        this.filteredCompanies = (this.companies || []).filter(company => 
          company && company.companyName && company.companyName.toLowerCase().includes(query)
        ).slice(0, 3);
        this.showSuggestions = this.filteredCompanies.length > 0;
      } else {
        this.filteredCompanies = this.companies || [];
        this.showSuggestions = this.filteredCompanies.length > 0; // Poprawiona literówka
      }
    },
    selectCompany(company) {
      this.currentCompany.companyName = company.companyName;
      this.localOrder.companyId = company.id;
      this.showSuggestions = false;
    },
    hideSuggestions() {
      setTimeout(() => {
        this.showSuggestions = false;
      }, 100);
    },
    filterPassengers() {
        this.showPassengerSuggestions = true;
        
        // 1. Oczyszczanie zapytania użytkownika (aby obsłużyć "bak" i "Bąk")
        const query = this.removeDiacritics(this.currentPassenger.passengerName); 

        if (!query) {
          this.filteredPassengers = []; // Resetowanie listy
          return;
        }

        this.filteredPassengers = this.passengers.filter(passenger => {
          // 2. Oczyszczanie danych pasażera
          const passengerFullName = `${passenger.lastName} ${passenger.firstName}`;
          const cleanedPassengerName = this.removeDiacritics(passengerFullName);

          // 3. Wyszukiwanie
          return cleanedPassengerName.includes(query);
        });

        // 4. Sortowanie (opcjonalne, ale dobre)
        this.filteredPassengers.sort((a, b) => a.lastName.localeCompare(b.lastName));

        // 5. OGRANICZENIE WYNIKÓW (slice(0, 3))
        this.filteredPassengers = this.filteredPassengers.slice(0, 3);
        
        this.showPassengerSuggestions = this.filteredPassengers.length > 0;
    },
    selectPassenger(passenger) {
      this.currentPassenger.passengerName = `${passenger.lastName} ${passenger.firstName}`;
      this.currentPassenger.firstName = passenger.firstName;
      this.currentPassenger.lastName = passenger.lastName;
      this.currentPassenger.city = passenger.city;
      this.currentPassenger.passengerId = passenger.id;
      this.currentPassenger.homeAddress = passenger.homeAddress;
      this.currentPassenger.workAddress = passenger.workAddress;
      this.showPassengerSuggestions = false;
    },
    hidePassengerSuggestions() {
      setTimeout(() => {
        this.showPassengerSuggestions = false;
      }, 100);
    },
    addPassenger() {
      console.log('addPassenger wywołane', this.currentPassenger);
      if (
        !this.currentPassenger.passengerName ||
        !this.currentPassenger.passengerId ||
        !this.currentPassenger.pickupAddress ||
        !this.currentPassenger.dropoffAddress
      ) {
        this.localErrors.passengerId = 'Wszystkie pola dla pasażera są wymagane';
        return;
      }

      if (!Array.isArray(this.localOrder.passengers)) {
        console.error('Local order passengers is not an array:', this.localOrder.passengers);
        this.localOrder.passengers = [];
      }
      if (!Array.isArray(this.localOrder.passengers)) {
        this.localOrder.passengers = [];
      }

      this.localOrder.passengers.push({ ...this.currentPassenger });

      if (this.swapEnabled && this.swappedPassenger.passengerId) {
          this.swappedPassenger.pickupTime = this.currentPassenger.pickupTime;
          this.swappedPassenger.passengerName = this.swappedPassenger.passengerName || `${this.currentPassenger.lastName} ${this.currentPassenger.firstName}`;
          this.swappedPassenger.pickupAddress = this.currentPassenger.dropoffAddress;
          this.localOrder.passengers.push({ ...this.swappedPassenger });
      }

      console.log(this.localOrder.passengers);

      // this.localOrder.passengers.push({ ...this.currentPassenger });
      this.currentPassenger = {
        passengerName: '',
        firstName: '',
        lastName: '',
        passengerId: null,
        pickupTime: '',
        pickupAddress: '',
        dropoffAddress: '',
        homeAddress: '',
        workAddress: '',
        sharedDropoff: false
      };
      this.swapEnabled = false;
      this.swappedPassenger = {
        passengerName: '',
        passengerId: null,
        pickupAddress: '',
        dropoffAddress: '',
        sharedDropoff: false
      };
      this.pickupOption = '';
      this.dropoffOption = '';
      this.localErrors.passengerId = '';
    },
    closeModal() {
      this.$emit('close');
    },
    submitForm() {
      this.$emit('submit', this.localOrder);
      this.resetForm();
    },
    resetForm() {
      this.localOrder = { ...this.newOrder, passengers: [] };
      this.currentCompany = {
        companyName: '',
        companyId: null,
      };
      this.currentPassenger = {
        passengerName: '',
        firstName: '',
        lastName: '',
        passengerId: null,
        pickupTime: '',
        pickupAddress: '',
        dropoffAddress: '',
        homeAddress: '',
        workAddress: '',
        sharedDropoff: false
      };
      this.localErrors = { ...this.errors };
      this.filteredCompanies = [];
      this.showSuggestions = false;
      this.filteredPassengers = [];
      this.showPassengerSuggestions = false;
      this.driverAddress = '';
      this.pickupOption = '';
      this.dropoffOption = '';
      this.filteredPickupAddresses = [];
      this.filteredDropoffAddresses = [];
      this.showPickupSuggestions = false;
      this.showDropoffSuggestions = false;
      this.editIndex = null;
      this.editPassenger = {};
      this.swapEnabled = false;
      this.swappedPassenger = {
        passengerName: '',
        passengerId: null,
        pickupAddress: '',
        dropoffAddress: '',
      };
      this.filteredSwappedPassengers = [];
      this.showSwappedPassengerSuggestions = false;
      this.filteredOrderLinks = [];
      this.showOrderLinkSuggestions = false;
    },
    validateField(field) {
      switch (field) {
        case 'mpk':
          this.localErrors.mpk = this.localOrder.mpk.length < 2 ? 'MPK musi mieć co najmniej 2 znaki' : '';
          break;
        case 'companyId':
          this.localErrors.companyId = !this.localOrder.companyId ? 'Firma jest wymagana' : '';
          break;
        case 'uniq_id':
          this.localErrors.uniq_id = !this.localOrder.uniq_id ? 'Unikalne ID jest wymagane' : '';
          break;
        case 'date':
          this.localErrors.date = !this.localOrder.date ? 'Data jest wymagana' : '';
          break;
      }
    },
    showDatePicker(event) {
      event.target.showPicker();
    },
    showTimePicker(event) {
      event.target.showPicker();
    },
    filterSwappedPassengers() {
        // 1. Oczyszczenie i normalizacja zapytania użytkownika
        const rawQuery = this.swappedPassenger.passengerName;
        const cleanedQuery = this.removeDiacritics(rawQuery).trim();

        if (cleanedQuery) {
            this.filteredSwappedPassengers = this.passengers
                .filter(passenger => {
                    
                    // 2. Oczyszczenie danych pasażera
                    const cleanedFirstName = this.removeDiacritics(passenger.firstName);
                    const cleanedLastName = this.removeDiacritics(passenger.lastName);
                    
                    // 3. Sprawdzenie, czy to nie jest pasażer obecnie edytowany
                    const isNotCurrentPassenger = passenger.id !== this.currentPassenger.passengerId;

                    // 4. Wyszukiwanie (Case- i Diacritic-Insensitive)
                    const matches = cleanedFirstName.includes(cleanedQuery) || cleanedLastName.includes(cleanedQuery);

                    return matches && isNotCurrentPassenger;
                })
                .sort((a, b) => a.lastName.localeCompare(b.lastName))
                .slice(0, 3); // Zachowanie ograniczenia do 3 wyników

            this.showSwappedPassengerSuggestions = this.filteredSwappedPassengers.length > 0;
        } else {
            // Gdy pole wyszukiwania jest puste, wyświetl wszystkich pasażerów oprócz obecnie edytowanego
            this.filteredSwappedPassengers = this.passengers.filter(p => p.id !== this.currentPassenger.passengerId);
            this.showSwappedPassengerSuggestions = this.filteredSwappedPassengers.length > 0;
        }
    },
    selectSwappedPassenger(passenger) {
      this.swappedPassenger.firstName = passenger.firstName;
      this.swappedPassenger.lastName = passenger.lastName;
      this.swappedPassenger.passengerName = `${passenger.lastName} ${passenger.firstName}`;
      this.swappedPassenger.passengerId = passenger.id;
      this.swappedPassenger.city = passenger.city;
      // Adres odbioru drugiego pasażera jest adresem dowozu pierwszego
      this.swappedPassenger.homeAddress = passenger.homeAddress;
      this.swappedPassenger.pickupAddress = this.currentPassenger.dropoffAddress;
      this.showSwappedPassengerSuggestions = false;
    },
    hideSwappedPassengerSuggestions() {
        setTimeout(() => {
          this.showSwappedPassengerSuggestions = false;
        }, 100);
      },
    filterSwappedDropoffAddresses() {
      const query = this.removeDiacritics(this.swappedPassenger.dropoffAddress);

      let allSuggestions = [];

      const homeAddress = this.removeDiacritics(this.swappedPassenger.city + " " + this.swappedPassenger.homeAddress);  
      const filteredHotels = this.hotels.filter(hotel => 
        this.removeDiacritics(hotel.name).includes(query) || 
        (hotel.address && this.removeDiacritics(hotel.address).includes(query))
      );

      allSuggestions = [
        {
          combined: homeAddress,
          name: homeAddress,
          postcode: ''
        },
        ...filteredHotels.map(hotel => ({
          combined: `${hotel.address || 'Brak adresu'} (${hotel.name})`, 
          name: hotel.name,
          address: hotel.address || 'Brak adresu'
        }))
      ];

      // allSuggestions.push({
      //   combined: homeAddress,
      //   name: homeAddress,
      //   postcode: ''
      // });

      this.filteredSwappedDropoffAddresses = allSuggestions;

      if (!query) {
        return;
      }

      if (query.length > 6) {
        this.swapPassengerSelected = true;
      }

      // const filteredStations = this.stations.filter(station =>
      //   station.name.toLowerCase().includes(query)
      // );

      // this.filteredSwappedDropoffAddresses = filteredStations.map(station => ({
      //   combined: `${station.name} ${station.postcode || 'Brak kodu'}`,
      //   name: station.name,
      //   postcode: station.postcode || 'Brak kodu'
      // }));

      this.filteredSwappedDropoffAddresses = allSuggestions;
    },
    selectSwappedDropoffAddress(address) {
      const finalAddress = address.address || address.combined;
      this.swappedPassenger.dropoffAddress = finalAddress;
      this.showSwappedDropoffSuggestions = false;
      this.swapPassengerSelected = true;
    },
    filterDrivers() {
        // 1. Oczyszczenie zapytania
        // Założenie: this.localOrder.driverName przechowuje tekst wprowadzony przez użytkownika.
        const rawQuery = this.localOrder.driverName;
        const cleanedQuery = this.removeDiacritics(rawQuery); // Użycie funkcji usuwającej diakrytyki

        if (cleanedQuery.length > 1) {
            this.filteredDrivers = this.drivers.filter(driver => {
                
                // 2. Oczyszczenie imienia i nazwiska kierowcy
                const cleanedFirstName = this.removeDiacritics(driver.firstName);
                const cleanedLastName = this.removeDiacritics(driver.lastName);

                // 3. Wyszukiwanie (Case- i Diacritic-Insensitive)
                return cleanedFirstName.includes(cleanedQuery) || 
                      cleanedLastName.includes(cleanedQuery);
            });
        } else {
            this.filteredDrivers = [];
        }
    },
    selectDriver(driver) {
      this.localOrder.driverId = driver.id;
      this.localOrder.driverName = `${driver.firstName} ${driver.lastName}`;
      this.showDriverSuggestions = false;
    },
    hideDriverSuggestions() {
      setTimeout(() => {
        this.showDriverSuggestions = false;
      }, 200);
    },
    hideSwappedDropoffSuggestions() {
      setTimeout(() => {
        this.showSwappedDropoffSuggestions = false;
      }, 100);
    },
    startDrag(event) {
        this.isDragging = true;
        
        event.currentTarget.classList.add('dragging');

        const clientX = event.clientX || event.touches[0].clientX;
        const clientY = event.clientY || event.touches[0].clientY;
        
        this.dragOffset.x = clientX - this.modalPosition.x;
        this.dragOffset.y = clientY - this.modalPosition.y;
        
        // Dodajemy event listeners
        document.addEventListener('mousemove', this.onDrag);
        document.addEventListener('touchmove', this.onDrag, { passive: false });
        document.addEventListener('mouseup', this.stopDrag);
        document.addEventListener('touchend', this.stopDrag);
      },
    onDrag(event) {
        if (!this.isDragging) return;
        
        event.preventDefault();
        
        const clientX = event.clientX || event.touches[0].clientX;
        const clientY = event.clientY || event.touches[0].clientY;
        
        this.modalPosition.x = clientX - this.dragOffset.x;
        this.modalPosition.y = clientY - this.dragOffset.y;
      },
    stopDrag() {
        this.isDragging = false;
        
        const dragElement = document.querySelector('.cursor-move');
        if (dragElement) {
          dragElement.classList.remove('dragging');
        }

        // Usuwamy event listeners
        document.removeEventListener('mousemove', this.onDrag);
        document.removeEventListener('touchmove', this.onDrag);
        document.removeEventListener('mouseup', this.stopDrag);
        document.removeEventListener('touchend', this.stopDrag);
      },
    resetPosition() {
        this.modalPosition = { x: 0, y: 0 };
    },
  }
};
</script>